module.exports = __webpack_public_path__ + "static/media/Health.50a02e70.svg";